export enum CurrencySymbolPositionEnum {
  LEADING = 'leading',
  TRAILING = 'trailing',
}
